export const PERFORMANCE_METRIC_TIMEOUT_MS = 60000;

export async function performanceForMetric(
  metric: 'largest-contentful-paint' | 'paint' | 'first-input'
): Promise<number | undefined> {
  if (typeof window.performance === 'undefined') {
    return undefined;
  }

  const entries = window.performance.getEntriesByType(metric);
  if (entries.length > 0) {
    return (entries[entries.length - 1] as PerformanceEntry).startTime;
  }

  return new Promise<number | undefined>((resolve) => {
    if (typeof PerformanceObserver === 'undefined') {
      resolve(undefined);
      return;
    }

    const timeoutId = setTimeout(() => {
      observer.disconnect();
      resolve(undefined);
    }, PERFORMANCE_METRIC_TIMEOUT_MS);
    const observer = new PerformanceObserver((list) => {
      const entriesOb = list.getEntries();
      if (entriesOb.length > 0) {
        observer.disconnect();
        clearTimeout(timeoutId);
        resolve((entriesOb[entriesOb.length - 1] as PerformanceEntry).startTime);
      }
    });

    observer.observe({ type: metric, buffered: true });
  });
}
